import React from 'react';
import {Badge, Button, FormGroup, InputGroup, InputGroupAddon, UncontrolledTooltip} from 'reactstrap';
import AutoComplete from '../components/AutoCompleteInput';
import {PayStatus, UserActivity} from "./Constants";
import Constants from "./AppVariables";
import {ToastsStore} from "react-toasts";

//  The default duration for toast messages
const DefaultToastDuration = 4500;

const Styles = {
    tractor:{
        marginBottom: '4px'
    }
};

class HtmlHelpers{

    //  Toast message
    static toastMessage(message) {
        ToastsStore.info(message, DefaultToastDuration);
    }

    static toastSuccess(message){
        ToastsStore.success(message,DefaultToastDuration , "text-white");
    }

    //  Toast error message
    static toastError(message) {
        ToastsStore.error(message, DefaultToastDuration, "text-white");
    }

    //  Toast warning message
    static toastWarning(message) {
        ToastsStore.warning(message, DefaultToastDuration);
    }

    static renderActionButton(disabled,onClick){
        return (<Button className="table-action-btn btn-circle" disabled={disabled} onClick={onClick}><i className="fa fa-plus"></i></Button>);
    }

    static renderEmail(name,hint,onGetRef) {
        return (
            <FormGroup>
                <InputGroup>
                    <InputGroupAddon>@</InputGroupAddon>
                    <input className="form-control" type='email' name={name} id={name} placeholder={hint} ref={onGetRef} required/>
                </InputGroup>
            </FormGroup>);
    }

    static renderInputAddon(name,hint,type,icon , onGetRef) {
        return (
            <FormGroup>
                <InputGroup>
                    <InputGroupAddon><i className={icon}></i></InputGroupAddon>
                    <input className="form-control" type={type} name={name} id={name} placeholder={hint} ref={onGetRef} required/>
                </InputGroup>
            </FormGroup>);
    }

    static renderSelectAddon(name,items,icon,onGetRef){
        return (<FormGroup className="form-group">
            <InputGroup >
                <InputGroupAddon><i className={icon}></i></InputGroupAddon>
                <select name={name} id={name} ref={onGetRef} className="form-control">
                    {items.map((item,index) =>{
                        return <option key={item.value}>{item.text}</option>
                    })}
                </select>
            </InputGroup>
        </FormGroup>);
    }

    static renderUserActivityStatus(user,style){

        let content;
        switch (user.status.activity_status){
            case UserActivity.Online:
                content = <Badge pill={true} color={"success"}>Online</Badge>;
                break;
            case UserActivity.Offline:
                content = <Badge pill={true}>Offline</Badge>;
                break;
        }

        return <h6 style={style}>{content}</h6>;
    }

    static renderTransactionStatus(request,onClick){

        let content;
        const payStatus = request.payment_status;
        switch (payStatus.status){

            case PayStatus.NotInitiated:
                content =  request.is_booking ? <Badge pill={true} color={"secondary"}><i className="fa fa-hourglass"></i> Booked</Badge> :
                    <Badge pill={true} color={"secondary"}>Not Initiated</Badge>;
                break;

            case PayStatus.InitiateReceive:
                content =  <Badge pill={true} color={"warning"}><i className="fa fa-money"></i> Charging...</Badge>;
                break;

            case PayStatus.InitiateRefund:
                content = <Badge pill={true} color={"warning"}><i className="fa fa-recycle"></i> Refunding...</Badge>;
                break;

            case PayStatus.Refunded:
                content = <Badge pill={true} color={"success"}> Refunded <i className="fa fa-recycle"></i></Badge>;
                break;

            case PayStatus.RefundPartial:
                content = <Badge pill={true} color={"success"}> Refunded (Partial) <i className="fa fa-recycle"></i></Badge>;
                break;

            case PayStatus.PaidFully:
                content = <Badge pill={true} color={"success"}> Paid <i className="fa fa-money"></i></Badge>;
                break;

            case PayStatus.PaidPartially:
                content = <Badge pill={true} color={"success"}> Paid (Partial) <i className="fa fa-money"></i></Badge>;
                break;

            case PayStatus.PaymentFail:
                content = <Badge pill={true} color={"danger"}> Failed (Payment) <i className="fa fa-money"></i></Badge>;
                break;

            case PayStatus.RefundFail:
                content = <Badge pill={true} color={"danger"}> Failed (Refund) <i className="fa fa-money"></i></Badge>;
                break;

            case PayStatus.Unknown:
                content = <Badge pill={true} color={"danger"}>Unknown</Badge>;
                break;
        }

        return <div>
            <h6 style={{ cursor: onClick ? "pointer" : "default" }} onClick={onClick}><span id={`request_${request.id}_pay_status`}>{content}</span> </h6>
            {payStatus.message && <UncontrolledTooltip target={`request_${request.id}_pay_status`} fade={false} placement="bottom">{payStatus.message}</UncontrolledTooltip>}
        </div>;
    }



    static renderPlacesInputAddon(placeholder,onGetRef,onPlaceSelected) {
        return (<FormGroup>
            <InputGroup>
                <InputGroupAddon><i className="fa fa-map-marker"></i></InputGroupAddon>

                <AutoComplete
                    ref={onGetRef}
                    className="form-control"
                    placeholder={placeholder}
                    style={{width: '100%'}}
                    onPlaceSelected={onPlaceSelected}
                    types={['(regions)']}
                    componentRestrictions={{country: Constants.PlacesAutoCompleteCountry }}
                />

            </InputGroup>
        </FormGroup>);
    }

    /**
     * Renders an icon
     * @param icon
     */
    static renderIcon(icon){

        if(icon == "tractor" || icon == "tractor_black"){
            return <img src="/img/avatars/tractor_logo.png" width={16} height={16} style={Styles.tractor}/>
        }
        else if(icon == "tractor_white"){
            return <img src="/img/avatars/tractor_logo_white.png" width={16} height={16} style={Styles.tractor} />
        }

        if(typeof  icon === "string")
            return <i className={icon}></i>;

        return icon;
    }


}


export default HtmlHelpers;


// WEBPACK FOOTER //
// ./src/common/HtmlHelpers.js